import { trans } from '@spotahome/soyuz/client';

import { isDefaultFilter } from '@spotahome/ui-library/src/tenant/components/utils/filters';

import {
  AGE,
  NATIONALITY,
  OCCUPATION,
  PROPERTY_TYPE_TO_SECTION_MAP,
  SECTION_ALL,
  SECTION_APARTMENT,
  SECTION_PROPERTY_TYPE_LABEL_MAP,
  SECTION_PROPERTY_TYPE_MAP,
  SECTION_RESIDENCE,
  SECTION_ROOM,
  SECTION_STUDIO
} from '../constants/seoCharts';

const MIN_PUBLISHED_PROPERTIES = 100;

export const shouldShowCharts = (totalPublishedProperties, filters) => {
  const onlyOnePropertyType = filters['type[]']?.length <= 1;

  return (
    totalPublishedProperties >= MIN_PUBLISHED_PROPERTIES &&
    onlyOnePropertyType &&
    isDefaultFilter(filters)
  );
};

export const getQueryPropertyType = propertyType =>
  propertyType in SECTION_PROPERTY_TYPE_MAP
    ? SECTION_PROPERTY_TYPE_MAP[propertyType]
    : null;

export const getPropertyTypeSections = () => [
  {
    id: SECTION_ALL,
    label: trans('charts.section.all-properties')
  },
  {
    id: SECTION_APARTMENT,
    label: trans('charts.section.apartments')
  },
  {
    id: SECTION_STUDIO,
    label: trans('charts.section.studios')
  },
  {
    id: SECTION_ROOM,
    label: trans('charts.section.rooms-shared')
  },
  {
    id: SECTION_RESIDENCE,
    label: trans('charts.section.student-residences')
  }
];

export const getTenantProfilesSections = () => [
  {
    id: NATIONALITY,
    label: trans('chart.section.nationality').toUpperCase()
  },
  {
    id: OCCUPATION,
    label: trans('chart.section.occupation').toUpperCase()
  },
  {
    id: AGE,
    label: trans('chart.section.age').toUpperCase()
  }
];

const escapeHtml = str =>
  String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

export const generateNoscriptTableHtml = ({ title, headers, rows }) => {
  if (!rows || rows.length === 0) return '';
  const caption = title ? `<caption>${escapeHtml(title)}</caption>` : '';
  const ths = headers.map(h => `<th>${escapeHtml(h)}</th>`).join('');
  const trs = rows
    .map(([c1, c2, delta]) => {
      const valueCell =
        delta != null
          ? `${escapeHtml(c2)} (${escapeHtml(String(delta))}%)`
          : escapeHtml(c2);
      return `<tr><td>${escapeHtml(c1)}</td><td>${valueCell}</td></tr>`;
    })
    .join('');
  return `<table>${caption}<thead><tr>${ths}</tr></thead><tbody>${trs}</tbody></table>`;
};

export const getPropertyTypeTranslation = propertyType => {
  if (SECTION_PROPERTY_TYPE_LABEL_MAP[propertyType]) {
    return trans(SECTION_PROPERTY_TYPE_LABEL_MAP[propertyType]).toLowerCase();
  }

  if (PROPERTY_TYPE_TO_SECTION_MAP[propertyType]) {
    return trans(
      SECTION_PROPERTY_TYPE_LABEL_MAP[
        PROPERTY_TYPE_TO_SECTION_MAP[propertyType]
      ]
    ).toLowerCase();
  }

  return '';
};
